import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { FormattedMessage } from "react-intl";

/**
 * MainTitle:
 *   - Maintitle for all Lelvel Selector Components
 */
export function MainTitle(props) {
  const className = `${style.text} ${props.className}`;
  return (
    <h2 className={className}>
      <FormattedMessage
        id={props.title}
        defaultMessage={props.title}
        description=""
      />
    </h2>
  );
}

MainTitle.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Title text
   */
  title: PropTypes.string,
};

MainTitle.defaultProps = {
  className: "",
};
